import { useGlobalModalsContext } from 'contexts/globalModalsContext';
import Link from 'ui/Link';
import Tooltip from 'ui/Tooltip';
import { Text } from 'ui/Typography';

import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import { useSankeyFileName } from '../../diagram/title';
import { useCurrentUser } from '../../utils/user';
import ViewOnlyInfo from '../ViewOnlyInfo';
import SaveInfo from './SaveInfo';

const SankeyBreadcrumb: React.FC = () => {
  const { openOpenDiagramModal, openBrowseTemplatesModal } =
    useGlobalModalsContext();

  const { isReadOnly } = useSankeyFormContext();
  const fileName = useSankeyFileName();
  const { user } = useCurrentUser();

  return (
    <>
      <Tooltip content="Click to open another diagram">
        <Link
          variant="neutral"
          minW={0}
          onClick={
            user?.is_authenticated
              ? openOpenDiagramModal
              : openBrowseTemplatesModal
          }
        >
          <Text truncate>{fileName}</Text>
        </Link>
      </Tooltip>
      {isReadOnly ? <ViewOnlyInfo /> : <SaveInfo />}
    </>
  );
};

export default SankeyBreadcrumb;
